import react from 'react';
export default class Modal extends react.Component {
  constructor(props) {
    super(props);

    this.state = { 
      show: props.show,
      header: props.header,
      hideAction: props.hideAction
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ show: nextProps.show });  
  }

  render() {
    if (!this.state.show)
      return <div></div>;
    //const showHideClassName = this.state.show ? "modal fade show" : "modal fade";
    return (
      <>
        <div className="modal fade show" tabIndex={-1} role="dialog" aria-labelledby="infoRouteGeneratorsTitle" aria-hidden="true" style= {{display:"block"}} onClick={
          () => this.setState({show:false})
        }>
          <div className="modal-dialog" role="document" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title" id="infoRouteGeneratorsTitle">{this.props.header}</h2>
              </div>
              <div className="modal-body">
                {this.props.children}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline-secondary modal-btn" data-dismiss="modal" onClick= {this.state.hideAction}
                  >Close</button>
              </div>
            </div>
        </div>
      </div>
    </>
    );
  }
}